module.exports = __webpack_public_path__ + "images/gems.png?5a93e25c569dfe38518f44c053362f67";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gems.png
// module id = 314
// module chunks = 0